import { Alert } from '@mui/material'
import { useAuth } from '../../context/AuthContext'

/**
 * Shown only when another browser tab changes auth (storage event) and this tab's
 * signed-in user or role no longer matches. Focus/visibility still refresh silently.
 */
export function SessionSyncBanner() {
  const { sessionSyncNotice, clearSessionSyncNotice } = useAuth()

  if (!sessionSyncNotice) return null

  return (
    <Alert
      severity="info"
      onClose={clearSessionSyncNotice}
      sx={{
        borderRadius: 0,
        flexShrink: 0,
        position: 'sticky',
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar,
      }}
    >
      {sessionSyncNotice.message}
    </Alert>
  )
}
